import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'pagination',
  templateUrl: './pagination.component.html'
})
export class PaginationComponent implements OnInit {
  @Input() currentPage: number;
  @Input() lastPage: number;
  @Output() changePageTo = new EventEmitter();

  constructor() {
  }

  changePage(page: number) {
    if(page > 0 && page < this.lastPage + 1) {
      this.changePageTo.emit(page);
    }
  }

  ngOnInit() {
  }

}
